import { render, staticRenderFns } from "./record-shipment.vue?vue&type=template&id=371e5ca9&scoped=true"
import script from "./record-shipment.vue?vue&type=script&lang=js"
export * from "./record-shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e5ca9",
  null
  
)

export default component.exports